export interface HighlightTextProps {
  text: string;
  query?: string;
}

/** Wraps the first case-insensitive match of `query` in `text` with `<mark>` — used by search
 *  results to show why a row matched. No-op (plain text) when `query` is empty/absent. */
export function HighlightText({ text, query }: HighlightTextProps) {
  if (!query?.trim()) return <>{text}</>;

  const index = text.toLowerCase().indexOf(query.trim().toLowerCase());
  if (index === -1) return <>{text}</>;

  const before = text.slice(0, index);
  const match = text.slice(index, index + query.trim().length);
  const after = text.slice(index + query.trim().length);

  return (
    <>
      {before}
      <mark>{match}</mark>
      {after}
    </>
  );
}
